// src/pages/Products/Edit.tsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ProductsAPI } from "../../api/products";
import { Product } from "../../types/products";
import ProductForm from "../../components/admin/ProductForm";

export default function ProductEdit() {
  const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    (async () => {
      try {
        setLoading(true);
        setErr(null);
        const data = await ProductsAPI.getById(id);
        setItem(data);
      } catch (e: any) {
        setErr(e?.message || "Failed to load");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (!id) return <div>Missing id</div>;
  if (loading) return <div>Loading…</div>;
  if (err) return <div style={{ color: "#b00" }}>{err}</div>;
  if (!item) return <div>Not found</div>;

  return (
    <div>
      <h1>Edit: {item.name}</h1>
      <ProductForm
        mode="edit"
        initial={item}
        onSaved={(saved) => setItem(saved)}
      />
    </div>
  );
}
